import { Collapse, Text, List, ListItem } from 'components';
import React from 'react';

const Instructions: React.FC = () => (
    <Collapse>
      <Collapse.Panel header="Instructions" key="1">
        <Text>
          <ol>
            <li>
              To remove replicated open houses from a listing, you will need a
              minimum of two pieces of information:
              <ol type="i" style={{ listStyle: 'lower-roman' }}>
                <li>
                  <strong>retsUniqueId</strong> of the retsopenhouse to be
                  removed
                  <ul>
                    <li>
                      can either be found on the retsopenhouse doc in db, or on
                      the open house object in <kbd>listing.openHouses</kbd> in
                      the network panel when when loading listing details UI.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>listingRef</strong> of the retsopenhouse to be
                  removed. To find the listingRef:
                  <ul>
                    <li>
                      Check the <kbd>lookupType</kbd> field value in
                      cartographer under the <kbd>RETS_OPEN_HOUSE</kbd> mapping
                      config for the MLS client that the listing belongs to.
                    </li>
                    <li>
                      If the <kbd>lookupType</kbd> is <kbd>mlsNumber</kbd>, then
                      the <kbd>listingRef</kbd> is just the <kbd>mlsNumber</kbd>{' '}
                      of the listing.
                    </li>
                    <li>
                      If the <kbd>lookupType</kbd> is <kbd>retsUniqueId</kbd>,
                      then the <kbd>listingRef</kbd> is the{' '}
                      <kbd>retsUniqueId</kbd> found on the listing&apos;s
                      retslisting db entry. Use listing mlsNumber and boardId to
                      find the retslisting corresponding to the listing in db.
                    </li>
                  </ul>
                </li>
              </ol>
            </li>
            <li>
              Below, enter the listingRef and a comma-separated list of
              retsUniqueId values of the open houses you want to remove from the
              listing. Click the Remove Open Houses to submit the form and
              remove them from the listing.
            </li>
            <li>
              The response will specify the number of open houses that were
              successfully removed from the listing.
            </li>
          </ol>
        </Text>
      </Collapse.Panel>
    </Collapse>
  );

export default Instructions;
